import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#030303] border-t border-white/5" data-testid="footer">
      <div className="container mx-auto px-5 sm:px-6 md:px-8 max-w-7xl py-10 sm:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_shopmaker-pro/artifacts/i58pj6l7_222%20%285%29.png" 
                alt="Stryx Logo" 
                className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
              />
              <div>
                <span className="font-['Cormorant_Garamond'] text-xl sm:text-2xl text-white tracking-[0.1em] sm:tracking-[0.15em] font-medium">STRYX</span>
                <span className="block text-[0.5rem] sm:text-[0.6rem] text-zinc-500 tracking-[0.15em] sm:tracking-[0.2em] uppercase">Web Solutions</span>
              </div>
            </Link>
            <p className="text-zinc-500 text-xs sm:text-sm leading-relaxed max-w-md mb-4 sm:mb-6">
              Prémium weboldalak és webshopok készítése vállalkozásoknak. 
              Nem csak szép, hanem eredményes digitális jelenlét.
            </p>
            <div className="flex items-center gap-4">
              <a 
                href="tel:+36305664154" 
                className="flex items-center gap-2 text-zinc-400 hover:text-[#D4AF37] transition-colors text-xs sm:text-sm"
              >
                <Phone className="w-3.5 h-3.5 sm:w-4 sm:h-4" strokeWidth={1.5} />
                +36 30 566 4154
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[0.65rem] sm:text-xs text-zinc-400 mb-4 sm:mb-6">Navigáció</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { href: "/", label: "Főoldal" },
                { href: "/szolgaltatasok", label: "Szolgáltatások" },
                { href: "/referenciak", label: "Referenciák" },
                { href: "/rolam", label: "Rólam" },
                { href: "/kapcsolat", label: "Kapcsolat" },
              ].map((link) => (
                <li key={link.href}>
                  <Link 
                    to={link.href}
                    className="text-zinc-500 hover:text-[#D4AF37] transition-colors text-xs sm:text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[0.65rem] sm:text-xs text-zinc-400 mb-4 sm:mb-6">Szolgáltatások</h4>
            <ul className="space-y-2 sm:space-y-3">
              {[
                { label: "Céges weboldalak", href: "/szolgaltatasok" },
                { label: "Landing oldalak", href: "/szolgaltatasok" },
                { label: "Webshop készítés", href: "/szolgaltatasok" },
                { label: "Tervezd meg", href: "/tervezo" },
              ].map((item) => (
                <li key={item.label}>
                  <Link 
                    to={item.href}
                    className="text-zinc-500 hover:text-[#D4AF37] transition-colors text-xs sm:text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 sm:mt-16 pt-6 sm:pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4">
          <p className="text-zinc-600 text-[0.65rem] sm:text-xs">
            © {currentYear} Stryx. Minden jog fenntartva.
          </p>
          <div className="flex items-center gap-4 sm:gap-6">
            <Link to="/adatvedelem" className="text-zinc-600 hover:text-zinc-400 text-[0.65rem] sm:text-xs transition-colors">
              Adatvédelem
            </Link>
            <Link to="/cookie-szabalyzat" className="text-zinc-600 hover:text-zinc-400 text-[0.65rem] sm:text-xs transition-colors">
              Cookie szabályzat
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
